import { render } from "./mg-404.vue?vue&type=template&id=00d07db0&scoped=true"
const script = {}

import "./mg-404.vue?vue&type=style&index=0&id=00d07db0&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d07db0"]])

export default __exports__